// extracted by mini-css-extract-plugin
export default {"wrap":"Mp-z","fullWidth":"Np-z","items":"Op-z","featureCss":"Pp-z","disabled":"Qp-z","imgCss":"Rp-z"};